<template>
  <div class="inter-wrap" v-show="isShowQuestionnaire">
    <div class="inter-mask"></div>
    <div class="inter-modal">
      <div class="inter-info">
        <div class="inter-head">
          <div class="inter-tit">问卷</div>
          <div><img @click="onSetQuestionnaireVisible(false)" :src="closeImg" alt="" /></div>
        </div>
        <questionnaire
          :questionnaire-sdk="questionnaireSdk"
          @status-changed="onStatusChanged"
          @to-show="onSetQuestionnaireVisible(true)"
          @to-hide="onSetQuestionnaireVisible(false)"
        />
      </div>
    </div>
  </div>
</template>
<script>
import zModal from '@/components/ZModal'
import { Questionnaire as QuestionnaireSDK } from '@polyv/interactions-receive-sdk'
import Questionnaire from '@polyv/interactions-receive-sdk-ui-default/lib/PcQuestionnarie'
import closeImg from '@/assets/icons/close.png'
export default {
  name: '',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      isImage: false,
      closeImg,
      questionnaireSdk: null, // 问卷SDK实例
      isShowQuestionnaire: false, // 是否显示问卷
    }
  },
  components: {
    zModal,
    Questionnaire,
  },
  async created() {
    this.initPolyIr()
  },
  beforeDestroy() {
    this.questionnaireSdk.destroy()
  },
  methods: {
    initPolyIr() {
      // const { QuestionnaireSDK } = window.PolyvIRSDK
      // const { Questionnaire } = window.PolyvIRSDK
      // console.log('Questionnaire', Questionnaire)
      // this.questionnaireSdk = new Questionnaire()
      this.questionnaireSdk = new QuestionnaireSDK()
      console.log('this.questionnaireSdk ', this.questionnaireSdk)
      this.questionnaireSdk.on(this.questionnaireSdk.events.QUESTIONNAIRE_ACHIEVEMENT, (msg) => {
        console.log('收到问卷统计事件：', msg)
      })
    },
    onSetQuestionnaireVisible(visible) {
      this.isShowQuestionnaire = visible
    },
    onStatusChanged(status) {
      // if (status === 'isShowResult' || status === 'isShowAnswer') {
      //   this.answerCardTitle = this.answerCardSdk.curSubmittedAnswer ? '答题结果' : '未作答'
      // } else {
      //   this.answerCardTitle = '答题卡'
      // }
    },
  },
}
</script>
<style lang="less" scoped>
.inter-wrap {
  z-index: 999;
  width: 100%;
}
.inter-mask {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1000;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.45);
  filter: alpha(opacity=50);
}
.inter-info {
  width: 600px;
  background-color: #fff;
  position: absolute;
  top: 100px;
  margin: 0 auto;
  z-index: 99999;
  border-radius: 10px;
}
.inter-modal {
  display: flex;
  align-content: center;
  justify-content: center;
}
.inter-head {
  display: flex;
  justify-content: space-between;
  padding: 20px;
}
.inter-head img {
  width: 12px;
  height: 12px;
}
.inter-tit {
  font-size: 14px;
  font-weight: bold;
  color: #000;
}
</style>
<style>
.inter-wrap .plv-iar-questionnaire-question__options--table {
  width: 100%;
}
</style>
